import React from 'react';
import {makeStyles} from '@material-ui/styles';

import {Form} from './components';
import SimpleToolbar from '../../components/Toolbar/SimpleToolbar';
import PropTypes from 'prop-types';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
  },
  content: {
    marginTop: theme.spacing(2),
  },
}));

const PaymentAgreementEdit = (props) => {
  const {Link , pageLink, title, ...rest} = props;
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <SimpleToolbar
         Link = {Link}
         pageLink = {'/finance/payment-agreements'}
         title = {'Payment Agreements'} />
      <div className={classes.content}>
        <Form edit={true}/>
      </div>
    </div>
  );
};

PaymentAgreementEdit.propTypes = {
  user: PropTypes.object,
  Link: PropTypes.elementType.isRequired,
  pageLink: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

export default PaymentAgreementEdit;
